import type { PaletteColor, ThemeOptions } from '@mui/material';
import { createComponents } from './create-components';
import { createPalette } from './create-palette';
import { createShadows } from './create-shadows';
import type { Contrast } from '../index';

interface Config {
  primaryColor?: PaletteColor;
  contrast?: Contrast;
}

export const createOptions = ({
  primaryColor,
  contrast
}: Config): ThemeOptions => {
  const palette = createPalette({ primaryColor, contrast });
  const components = createComponents({ palette });
  const shadows = createShadows();

  return {
    components,
    palette,
    shadows
  };
};
